/* eslint-disable max-len */
import React from 'react';
import { LayoutContext } from './layout-context';

export function withLayoutContext(Component) {
  return props => (
    <LayoutContext.Consumer>
      {({ config, change, isGridLayout }) => (<Component {...props} changeLayout={change} layoutConfig={config} isGridLayout={isGridLayout} />)}
    </LayoutContext.Consumer>
  );
}
